import { Button } from "@/components/ui/button";

// Inscription / connexion via Google (Emergent Auth).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// `afterPath` (optionnel) : où renvoyer l'utilisateur après Google (ex. un tunnel partenaire).
export default function GoogleAuthButton({ label = "Continuer avec Google", afterPath = "" }) {
  const go = () => {
    // On mémorise la destination post-login pour la relire dans le callback Google.
    try {
      if (afterPath) localStorage.setItem("google_after_login", afterPath);
      else localStorage.removeItem("google_after_login");
    } catch {}
    const redirectUrl = window.location.origin + "/auth/google";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button
      type="button"
      variant="outline"
      onClick={go}
      data-testid="google-auth-btn"
      className="w-full h-11 gap-2 border-slate-300 font-semibold text-slate-700 hover:bg-slate-50"
    >
      <img src="https://www.google.com/favicon.ico" alt="" className="h-4 w-4" />
      {label}
    </Button>
  );
}
